import React from 'react';

import { Box, Grid, Typography } from '@material-ui/core';
import { NavLink } from 'react-router-dom';
import styled from 'styled-components';

import { CustomButton } from 'src/components';
import successLogo from 'src/medias/icons/icon-success.png';
import NanYangSchoolImage from 'src/medias/images/nanyang-school-full-size.png';
import useResponsive from 'src/utils/responsive';

export const NYSImage = styled.img(({ theme }) => ({
  width: '100%',
  height: '100vh',
}));
export const Container = styled(Typography)(({ theme }) => ({
  color: theme.palette.common.white,
  position: 'absolute',
  top: '40%',
  width: '100%',
  textAlign: 'center',
}));
export const Header = styled(Typography)<{ isTabletOrMobile?: boolean }>(({ theme, isTabletOrMobile }) => ({
  ...theme.fonts.textXL,
  fontSize: isTabletOrMobile ? theme.fonts.header3.fontSize : theme.fonts.textXL.fontSize,
  margin: '40px',
}));
export const OkBtn = styled(CustomButton)(({ theme }) => ({}));
export const NavLinkCustom = styled(NavLink)(({ theme }) => ({
  textDecoration: 'none',
}));
export const SuccessLogo = styled.img<{ isTabletOrMobile?: boolean }>(({ theme, isTabletOrMobile }) => ({
  width: isTabletOrMobile ? '90px' : 'auto',
}));

function ResetPasswordSuccess({ message }: { message: string }) {
  const { isTabletOrMobile } = useResponsive();
  return (
    <Grid xs={12}>
      <Box display="flex" position="relative">
        <NYSImage src={NanYangSchoolImage} />
        <Container>
          <SuccessLogo isTabletOrMobile={isTabletOrMobile} src={successLogo} />
          <Header isTabletOrMobile={isTabletOrMobile}>
            {message === 'sent-email' ? 'Email has been sent. Please check your mail!' : 'Your password is updated!'}
          </Header>
          {message === 'sent-email' ? (
            <NavLinkCustom to="/">
              <OkBtn>GO TO HOMEPAGE</OkBtn>
            </NavLinkCustom>
          ) : (
            <NavLinkCustom to="/login">
              <OkBtn>LOGIN</OkBtn>
            </NavLinkCustom>
          )}
        </Container>
      </Box>
    </Grid>
  );
}

export default ResetPasswordSuccess;
